<template>
    <div>
    </div>
</template>

<script>
    

    export default {
        name: "ConnectedCarRedirectPage",

        data() {
            return {

            }
        },

        created() {
            let search = window.location.search
            this.doRedirect(search);
        },

        methods: {
            doRedirect(search) {
                this.$router.push("/connected-car"+search)
            },
        },
    }
</script>

<style scoped>

</style>